import { API_ENDPOINTS, DELIVERY } from "../constants/apiConfig";
import { makeRequest } from "../middleware/axiosMiddleware"

export const deliveryService = {
    getDeliveryList,
    getDeliveryDetails,
    getBillingDetails,
    getListOfReturnItems,
    cancelReturnRequest,
    createExcessReturnRequest,
    downloadInvoice,
    downloadExcel,
    getReturnSalesReasonAPI,
    saveReturnRequestAPI,
    updateReturnStatus,
    viewReturnOrderAPI,
    raiseReturnRequestAPI,
    viewRetrunOrderForm,
    getListOfDownloadInvoice
};

async function getDeliveryList(orderNumber: any, enquiryNumber: any, make: any, backOrderNumber: any, sapId: any, orgId?: any, page?: any) {
    const apiPath = API_ENDPOINTS.DELIVERY + DELIVERY.LIST;
    const options = {
        path: `${apiPath}`,
        method: "POST",
        bodyObj: {
            "deliveryList": {
                "salesDocument": orderNumber ? orderNumber : "",
                "forwardOrderNumber": "",
                "shippingReceivingPoint": "",
                "description": "",
                "delivery": "",
                "pickingStatus": "",
                "shippingPlanningStatus": "",
                "goodsMovementStatus": "",
                "actualGoodsMovementDate": "",
                "billingStatus": "",
                "billingDateForBillingIndexPrintout": ""
            },
            "sessionDetails": {
                "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
                "clientIPAddress": sessionStorage.getItem('clientIp'),
            },
            "enquiryNumber": enquiryNumber,
            "make": make,
            "sapCustomerId": sapId,
            "orgId": orgId || "",
        },
        customHeaders: {
            // "Paging-Info": `start-index=${page ? page : 0}|no-of-records=10`
        },
        formdata: true
    };
    return await makeRequest(options)
}

async function getDeliveryDetails(enquiryNumber: any, deliveryNumber: any, make: any, orgId: any, sapId: any, page?: any) {
    const apiPath = API_ENDPOINTS.DELIVERY + DELIVERY.DETAILS;
    const options = {
        path: `${apiPath}`,
        method: "POST",
        bodyObj: {
            "sessionDetails": {
                "webApplicationLoginId": sessionStorage.getItem('webApplicationLoginId'),
                "clientIPAddress": sessionStorage.getItem('clientIp'),
            },
            "enquiryNumber": enquiryNumber,
            "delivery": deliveryNumber,
            "make": make,
            "orgId": orgId,
            "sapCustomerId": sapId,
        },
        customHeaders: {
            "Paging-Info": `start-index=${page ? page * 10 : 0}|no-of-records=10`
        },
        formdata: true
    };
    return await makeRequest(options)
}

async function downloadInvoice(deliveryNumber: any, enquiryNumber: any, searchByInvoice: any = '') {
    let apiPath = API_ENDPOINTS.DELIVERY + `/delivery/invoice?deliveryNumber=${deliveryNumber}&orgId=${enquiryNumber}`;
    if (searchByInvoice) {
        apiPath += '&downloadFor=searchByInvoice';
    }
    const options = {
        path: `${apiPath}`,
        method: "GET",
        bodyObj: {
        },
        customHeaders: {
        },
        FormData: true
    }
    return await makeRequest(options)
}
async function downloadExcel(data: any) {
    const apiPath = API_ENDPOINTS.DOWNLOADEXCEL;
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    };
    return await makeRequest(options)
}
async function getReturnSalesReasonAPI() {
    const apiPath = API_ENDPOINTS.RETURN_SALES_REASON;
    const options = {
        path: `${apiPath}`,
        method: "GET",
        bodyObj: {
        },
        customHeaders: {
        },
        FormData: true
    }
    return await makeRequest(options)
}

async function getBillingDetails(data: any) {
    const apiPath = API_ENDPOINTS.DELIVERY_INVOICE;
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    };
    return await makeRequest(options)
}

async function getListOfReturnItems(data: any) {
    const apiPath = API_ENDPOINTS.DELIVERY_INVOICE_API + `/salesReturn/returnOrders`;
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    };
    return await makeRequest(options)
}
async function getListOfDownloadInvoice(data: any) {
    const apiPath = API_ENDPOINTS.DELIVERY_INVOICE_API + `/getInvoiceList`;
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    };
    return await makeRequest(options)
}

async function cancelReturnRequest(data: any) {
    const apiPath = API_ENDPOINTS.CANCEL_RETURN;
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    }
    return await makeRequest(options)
}

async function createExcessReturnRequest(data: any) {
    const apiPath = API_ENDPOINTS.EXCESS_RETURN;
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    }
    return await makeRequest(options)
}

async function updateReturnStatus(data: any) {
    const apiPath = API_ENDPOINTS.UPDATE_RETURN_STATUS;
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    }
    return await makeRequest(options)
}

async function saveReturnRequestAPI(data: any) {
    const apiPath = API_ENDPOINTS.DELIVERY_INVOICE_API + `/salesReturn/saveReturnRequest`;
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    };
    return await makeRequest(options)
}

async function viewReturnOrderAPI(data: any) {
    const apiPath = API_ENDPOINTS.DELIVERY_INVOICE_API + `/salesReturn/viewReturnOrder`;
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    };
    return await makeRequest(options)
}

async function viewRetrunOrderForm(data: any) {
    const apiPath = API_ENDPOINTS.DELIVERY_INVOICE_API + `/salesReturn/getReturnForm`;
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    };
    return await makeRequest(options)
}

async function raiseReturnRequestAPI(data: any) {
    const apiPath = API_ENDPOINTS.DELIVERY_INVOICE_API + `/salesReturn/returnRequest`;
    const options = {
        path: apiPath,
        method: "POST",
        bodyObj: data,
        customHeaders: {},
        formdata: true
    };
    return await makeRequest(options)
}